import React from "react";
import { useNavigate } from "react-router-dom";
import UserMenu from "./UserMenu";
import HamburgerMenu from "./HamburgerMenu";
import { AiOutlineFileProtect } from "react-icons/ai";
import { ENV } from "../config/env";

// Logo default servido por nginx desde /branding/ (overrideable por volumen)
const defaultLogo = "/branding/logo.png";

const CommonHeader = ({ onAdminAction, onLogout }) => {
  const navigate = useNavigate();
  const goHome = () => navigate("/");
  return (
    <header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
        backgroundColor: "#00468B",
        color: "#FFFFFF",
      }}
    >
      <img
        src={ENV.LOGO_URL || defaultLogo}
        alt={ENV.LOGO_ALT}
        style={{ height: "50px", width: "auto" }}
      />
      <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
        <div
          onClick={goHome}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") goHome(); }}
          role="button"
          tabIndex={0}
          aria-label="Ir al inicio"
          title="Ir al inicio"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#FFFFFF",
            borderRadius: "50%",
            height: "60px",
            width: "60px",
            marginBottom: "5px",
            cursor: "pointer",
          }}
        >
          <AiOutlineFileProtect size={30} color="#00468B" />
        </div>
        {/* White-label: título del header oculto a pedido del cliente. El nombre
            configurable (ENV.APP_NAME) vive en landing, login y footer. */}
        {/* <h1 style={{ margin: 0, fontSize: "18px", fontWeight: "bold" }}>Bóveda Documental</h1> */}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <UserMenu onLogout={onLogout} />
        <HamburgerMenu onAdminAction={onAdminAction} />
      </div>
    </header>
  );
};

export default CommonHeader;
